module.exports = __webpack_public_path__ + "static/redbook-ae324bbc20b65d409998b89b8a6a6f36.gif";